import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./Role.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { IRole } from "./IRole";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import RoleForm from "./RoleForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listRole } from "../../Redux/Slices/Role/ListRoleSlice";
import { clearAddRoleResponse } from "../../Redux/Slices/Role/AddRoleSlice";
import {
  clearDeleteRoleResponse,
  deleteRole,
} from "../../Redux/Slices/Role/DeleteRoleSlice";
import { clearEditRoleResponse } from "../../Redux/Slices/Role/EditRoleSlice";
import { listSideMenuPermission, ISideMenu } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { useNavigate } from "react-router-dom";
import LaunchIcon from "@mui/icons-material/Launch";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LogoutIcon from "@mui/icons-material/Logout";

interface RoleProps {}

const Role: FunctionComponent<RoleProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<IRole | {}>({
    status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listRoles } = useAppSelector((state) => state.ListRoleSlice);
  const { data: addRole } = useAppSelector((state) => state.AddRoleSlice);
  const { data: EditRole } = useAppSelector((state) => state.EditRoleSlice);
  const { data: deleteRoles } = useAppSelector((state) => state.DeleteRole);

  const navigate = useNavigate();

  // user permisssion
  const userPermissionlist = useAppSelector(
    (state) => (state.SideMenuPermission as ISideMenu).data
  );

  const to = "settings";

  const filteredList = userPermissionlist?.Dashboard?.filter(
    (item: any) => item.to === to
  ) || [];
  const fliterdata: any = filteredList[0]?.items || [];
  const finaldata = fliterdata[0];

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      renderHeader: () => <b>Role</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IRole>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row });
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({ id: params.id, name: params?.row?.name });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              // disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                // setInitialValues({ ...params.row });
                // setDialogOpen(true);
                navigate("/settings/role-mapping-master", {
                  state: {
                    screen_search_query: params.row.name
                  }
                })
              }}
            >
              <LaunchIcon
                fontSize="small"
                sx={{
                  color: "#030505",
                }}
              />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const Role = Array.isArray(listRoles?.data)
    ? listRoles?.data.map((user, index) => ({ ...user, index: index + 1 }))
    : [];

  useEffect(() => {
    dispatch(listRole());
    // dispatch(listSideMenuPermission());
  }, [addRole, EditRole, deleteRoles, dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddRoleResponse());
      dispatch(clearEditRoleResponse());
      dispatch(clearDeleteRoleResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={Role ?? []} columns={columns}>
        <CustomToolbar>
          {/* <h6>Role</h6> */}
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => setDialogOpen(true)}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listRole())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog"
        Dialog_Title={`${(initialValues as IRole).id ? "Update" : "Add"} Role`}
        dialogContentClassName="dialog_content"
        Dialog_Content={
          <RoleForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setDialogOpen(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog response={addRole} parentDialog={setDialogOpen} />
      <ResponseDialog response={EditRole} parentDialog={setDialogOpen} />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteRole(deleteDialogData.id));
        }}
        response={deleteRoles}
      />
    </>
  );
};

export default Role;
